import React from "react";
import {
  Alert,
  Form,
  Icon,
  Button,
  Select,
  Row,
  Col,
  Modal,
  Tooltip,
} from "antd";
import get from "lodash/get";
import find from "lodash/find";
import map from "lodash/map";
import { connect } from "react-redux";

import {
  updateUserRoleRequest,
  createUserRoleRequest,
  toggleUserActivateRoleRequest,
} from "../../api/requests";
import { getUserUpdatePermission } from "../../reducers/user/selectors";

import classes from "./SettingsUserRoleForm.css";
import { logout } from "../../reducers/user/actions";
import classnames from "classnames";
import { withNamespaces } from "react-i18next";

const { Option } = Select;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}

class SettingsUserRoleForm extends React.Component {
  constructor(props) {
    super(props);

    const openGroups = {};
    const fieldKeys = Object.keys(this.props.permissionsStructure);
    fieldKeys.forEach((key) => {
      openGroups[key] = true;
    });

    this.state = {
      isLoading: false,
      requestResult: {},
      deactivateSubmitModal: false,
      roleState: "",
      openGroups,
    };
  }

  componentDidMount() {
    this.setState({ roleState: get(this.props, "selectedRole.state") });
  }

  showDeactivateModal = () => {
    this.setState({ deactivateSubmitModal: true });
  };
  hideDeactivateModal = () => {
    this.setState({ deactivateSubmitModal: false });
  };

  toggleActivate = async () => {
    try {
      await toggleUserActivateRoleRequest(
        this.props.userID,
        get(this.props, "selectedRole.id"),
        this.state.roleState
      );
      this.setState({
        requestResult: {
          type: "success",
          message: this.props.i18n.t("Success"),
        },
        roleState: this.state.roleState === "inactive" ? "active" : "inactive",
      });
      this.hideDeactivateModal();
      setTimeout(() => {
        this.props.onSubmit(get(this.props, "selectedRole.id"));
      }, 1000);
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
      }
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          if (!this.props.isNew) {
            await updateUserRoleRequest(
              this.props.userID,
              get(this.props, "selectedRole.id"),
              {
                user_id: this.props.userID,
                site_id: values.site_id,
                user_role_id: values.user_role_id,
              }
            );
          } else {
            await createUserRoleRequest(this.props.userID, {
              site_id: values.site_id,
              user_role_id: values.user_role_id,
            });
          }

          this.setState({
            isLoading: false,
            requestResult: { type: "success", message: this.props.i18n.t("Success") },
          });

          setTimeout(() => {
            this.props.onSubmit(this.props.id);
          }, 1000);
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: get(e, "response.data.message", this.props.i18n.t("Error")),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};
            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  collapseSection = (sectionName) => () => {
    this.setState((state) => ({
      openGroups: {
        ...state.openGroups,
        [sectionName]: !state.openGroups[sectionName],
      },
    }));
  };

  render() {
    const {
      isLoading,
      requestResult,
      deactivateSubmitModal,
      openGroups,
    } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const {
      userUpdatePermission,
      isNew,
      rolesList,
      sitesList,
      selectedRole,
    } = this.props;
    const selectedRolePermissions =
      find(
        rolesList,
        (roleItem) => roleItem.id === getFieldValue("user_role_id")
      ) || {};

    const isEditable = userUpdatePermission;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">
            {get(selectedRole, "id") ? this.props.i18n.t("Edit role") : isNew ? this.props.i18n.t("Add role") : ""}
          </h4>

          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t("Sites")}:</b>
                <Form.Item>
                  {getFieldDecorator("site_id", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "selectedRole.site.id", ""),
                  })(
                    <Select
                      disabled={!isEditable}
                      placeholder={this.props.i18n.t("Select Site")}
                      showSearch
                      optionFilterProp="children"
                    >
                      {sitesList
                        .sort(
                          (a, b) =>
                            +`${a.code}`.split("-")[0] -
                            +`${b.code}`.split("-")[0]
                        )
                        .map((site) => (
                          <Option key={site.id} value={site.id}>
                            {site.code} - {site.name}
                          </Option>
                        ))}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t("Roles")}:</b>
                <Form.Item>
                  {getFieldDecorator("user_role_id", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(
                      this.props,
                      "selectedRole.user_role.id",
                      ""
                    ),
                  })(
                    <Select
                      disabled={!isEditable}
                      placeholder={this.props.i18n.t("Select Role")}
                    >
                      {rolesList.map((role) => (
                        <Option
                          key={role.id}
                          value={role.id}
                          disabled={role.state === "inactive"}
                        >
                          {role.name}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          {!isNew && (
            <Row gutter={12}>
              <Col>
                <p>
                  <Button
                    type="danger"
                    style={{
                      backgroundColor:
                        this.state.roleState === "inactive"
                          ? "#44c721"
                          : "#f56009",
                      borderColor: "#fff",
                      color: "#fff",
                    }}
                    onClick={this.showDeactivateModal}
                  >
                    {this.state.roleState === "inactive"
                      ? this.props.i18n.t("Activate")
                      : this.props.i18n.t("Deactivate")}
                  </Button>
                </p>
              </Col>
            </Row>
          )}

          {requestResult.type && (
            <Alert
              message={requestResult.message}
              type={requestResult.type}
              className={classes.submitResult}
            />
          )}

          <div className={classes.actionWrapper}>
            {isEditable && (
              <Form.Item>
                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  className={classes.submitButton}
                >
                  {this.props.i18n.t("Save")}
                  {isLoading && <Icon type="loading" />}
                </Button>
              </Form.Item>
            )}
            &nbsp; &nbsp;
            <Button
              type="default"
              size="large"
              htmlType="button"
              className={classes.submitButton}
              onClick={this.props.onCancel}
            >
              {this.props.i18n.t("Cancel")}
            </Button>
          </div>

          <br />
          <br />

          {selectedRole && selectedRole.user_role && (
            <div>
              {Object.keys(this.props.permissionsStructure).map(
                (fieldGroupName) => {
                  return (
                    <div
                      key={fieldGroupName}
                      className={classes.fieldGroupwrapper}
                    >
                      <h5
                        className={classnames(
                          "headline-default",
                          classes.toggleHeadline
                        )}
                        onClick={this.collapseSection(fieldGroupName)}
                      >
                        <Tooltip
                          title={
                            openGroups[fieldGroupName] ? "collapse" : "show"
                          }
                        >
                          <Icon
                            type="arrow-up"
                            className={classes.collapseIcon}
                            style={{
                              fontSize: "20px",
                              transform: `rotate(${
                                openGroups[fieldGroupName] ? "0" : "180deg"
                              })`,
                            }}
                          />{" "}
                          &nbsp;
                        </Tooltip>

                        <span className={classes.headlineText}>
                          {get(
                            this.props.permissionsStructure[fieldGroupName],
                            "name"
                          )}
                        </span>
                      </h5>

                      {openGroups[fieldGroupName] && (
                        <div>
                          {get(
                            this.props.permissionsStructure[fieldGroupName],
                            "fields",
                            []
                          ).map((field) => {
                            return (
                              <div
                                className={classes.fieldItemwrapper}
                                key={field.key}
                              >
                                {field.permissions ? (
                                  <div>
                                    <h6 className="headline-default">
                                      {field.name}
                                    </h6>
                                    {field.permissions.map((permission) => (
                                      <div key={permission.key}>
                                        <Icon
                                          className={
                                            selectedRole.user_role.permissions.includes(
                                              +permission.key
                                            )
                                              ? classes.iconOk
                                              : classes.iconNot
                                          }
                                          type={
                                            selectedRole.user_role.permissions.includes(
                                              +permission.key
                                            )
                                              ? "check-square"
                                              : "stop"
                                          }
                                        />
                                        &nbsp;
                                        {permission.value}
                                      </div>
                                    ))}
                                  </div>
                                ) : (
                                  <h6 className="headline-default">
                                    <Icon
                                      className={
                                        selectedRole.user_role.permissions.includes(
                                          +field.key
                                        )
                                          ? classes.iconOk
                                          : classes.iconNot
                                      }
                                      type={
                                        selectedRole.user_role.permissions.includes(
                                          +field.key
                                        )
                                          ? "check-square"
                                          : "stop"
                                      }
                                    />{" "}
                                    &nbsp;{field.name}
                                  </h6>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  );
                }
              )}
            </div>
          )}
        </Form>

        <Modal
          title={`Role ${
            this.state.roleState === "inactive" ? "Activate" : "Deactivate"
          }`}
          visible={deactivateSubmitModal}
          onOk={this.toggleActivate}
          onCancel={this.hideDeactivateModal}
        >
          <p>
            {this.state.roleState === "inactive"
              ? this.props.i18n.t(
                  "NamespaceSettingsUserRoleForm:Confirm role activate action"
                )
              : this.props.i18n.t(
                  "NamespaceSettingsUserRoleForm:Confirm role deactivate action"
                )}
          </p>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userUpdatePermission: getUserUpdatePermission(state),
});

const mapDispatchToProps = { logout };

export default Form.create({ name: "user" })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(SettingsUserRoleForm))
);



// WEBPACK FOOTER //
// ./src/components/SettingsUserRoleForm/SettingsUserRoleForm.js